<template>
<div class="loading-page">
  <div class="tips-text">BEST GAMING OLATFORM</div>
  <div class="icon-box">
    <div :class="['icon', animation_index === 0 ? 'icon1_active' : 'icon1']">
    </div>
    <div :class="['icon', animation_index === 1 ? 'icon2_active' : 'icon2']">
    </div>
    <div :class="['icon', animation_index === 2 ? 'icon3_active' : 'icon3']">
    </div>
    <div :class="['icon', animation_index === 3 ? 'icon4_active' : 'icon4']">
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      animation_index: 0,
      timer: null,
    }
  },
  mounted() {
    this.startAnimation();

  },
  methods: {
    startAnimation() {
      this.timer = setInterval(() => {
        this.animation_index = (this.animation_index + 1) % 4;
      }, 300);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
.loading-page {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #202125;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30vh;
  z-index: 9999;
  .tips-text {
    font-size: .48rem;
    color: #bbb;
    margin-bottom: .6rem;
  }
  .icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: .6rem;
      height: .6rem;
      margin: 0 .35rem;
      background-image: url("/static/image/new/loading-icon.webp");
      background-size: 2.5rem 1.2rem; /* 整张雪碧图大小，必须设置 */
      transform-origin: left top;
      &.icon1 {
        background-position: 100% 100%;
      }
      &.icon1_active {
        background-position: 66% 100%;
        transform-origin: right bottom;
        animation: slowUpFastDown 0.3s forwards;

      }
      &.icon2 {
        background-position: 33% 0;
      }
      &.icon2_active {
        background-position: 0% 0%;
        animation: slowUpFastDown 0.3s forwards;
      }
      &.icon3 {
        background-position: 33% 100%;
      }
      &.icon3_active {
        background-position: 0% 100%;
        animation: slowUpFastDown 0.3s forwards;

      }
      &.icon4 {
        background-position: 100% 0%;
      }
      &.icon4_active {
        background-position: 66% 0%;
        animation: slowUpFastDown 0.3s forwards;
      }
    }
    @keyframes slowUpFastDown {
      0% {
        transform: rotate(0deg) scale(1);
      }
      20% {
        transform: rotate(10deg) scale(1); /* 先倾斜 */
      }
      70% {
        transform: rotate(10deg) scale(1.4); /* 再放大（慢） */
      }
      100% {
        transform: rotate(0deg) scale(1); /* 快速回到原样 */
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/loading.vue